import { Link } from 'react-router-dom';

import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>404</h1>
      <p className={styles.message}>Página não encontrada</p>
      <Link to='/' className={styles.link}>Voltar para a página inicial</Link>
    </div>
  );
}
